export function filterMap<T>(obj: { [key: string]: T }, predicate: (value: T) => boolean): { [key: string]: T } {
	return Object.keys(obj)
		.filter((_key) => predicate(obj[_key]))
		.reduce((_res: any, _key) => ((_res[_key] = obj[_key]), _res), {});
}
